import React from 'react'
import EmployeeEditContainer from '../../containers/employeemng/EmployeeEditContainer'

const EmployeeEditPage = () => {
    return <EmployeeEditContainer/>
}

export default EmployeeEditPage
